import React from 'react';

const ContactForm = () => {
    return (
        <section className="backlight-top is-fullwidth">
            <div className="stg-row stg-valign-middle stg-cta-with-image stg-tp-column-reverse">
                <div className="stg-col-5" data-unload="fade-left">
                    <div className="infocolors-offset-image" data-bg-src="img/cta/contact-section-bg.jpg" data-appear="fade-up" data-threshold="0.25"></div>
                    <form action="mail.php" method="post" className="infocolors-contact-form infocolors-block" data-fill-error="Please, fill out the contact form." data-appear="fade-right" data-threshold="0.25">
                        <div className="infocolors-form-content">
                            <label htmlFor="name">Your Name</label>
                            <input type="text" id="name" name="name" placeholder="Your Name" required />
                            <label htmlFor="email">Your Email</label>
                            <input type="email" id="email" name="email" placeholder="email@example.com" required />
                            <label htmlFor="message">Your Message</label>
                            <textarea id="message" name="message" placeholder="Your Message" required></textarea>
                            <button type="submit" value="Send Message">Get a FREE Quote</button>
                            <div className="infocolors-contact-form__response"></div>
                        </div>
                        <span className="infocolors-form-spinner"></span>
                    </form>
                </div>
                <div className="stg-col-6 stg-offset-1" data-unload="fade-right">
                    <div className="infocolors-cta-form-content">
                        <div className="infocolors-cta-form-title" data-split-appear="fade-up" data-split-delay="100" data-split-by="line">
                            Let's discuss your next creative project.
                        </div>
                        <div className="infocolors-cta-text">
                            <div className="stg-row stg-valign-middle">
                                <div className="stg-col-2 stg-offset-2 stg-tp-col-1 stg-tp-offset-3 stg-m-col-1 stg-m-offset-2" data-appear="fade-right">
                                    <i className="infocolors-cta-icon"></i>
                                </div>
                                <div className="stg-col-8 stg-tp-col-7 stg-m-col-8 stg-m-offset-1" data-appear="fade-left">
                                    <p className="infocolors-large-text">We help creative individuals and businesses, bring to live thier one of a kind ideas.</p>
                                </div>
                            </div>
                        </div>
                        <div className="infocolors-cta-counters infocolors-grid-3cols infocolors-m-grid-3cols" data-stagger-appear="fade-up" data-stagger-delay="100">
                            <div className="infocolors-counter infocolors-small-counter" data-delay="3000">
                                <div className="infocolors-counter-number">50</div>
                                <div className="infocolors-counter-label">Projects Done</div>
                            </div>
                            <div className="infocolors-counter infocolors-small-counter" data-delay="3000">
                                <div className="infocolors-counter-number" data-suffix="+">40</div>
                                <div className="infocolors-counter-label">Happy Clients</div>
                            </div>
                            <div className="infocolors-counter infocolors-small-counter" data-delay="3000">
                                <div className="infocolors-counter-number" data-suffix="+">5</div>
                                <div className="infocolors-counter-label">Years in Work</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactForm;
